// Modules
import Cookies from 'js-cookie'
import { call, put, takeEvery } from 'redux-saga/effects'
import { routers } from '../../navigation/constants'

// Languages
import {
  LN_LANDING_CONTACTS_PAGE_FORM_ERROR_MESSAGE,
  LN_LANDING_CONTACTS_PAGE_FORM_SUCCESS_MESSAGE,
  LN_NOTIFICATIONS_FORGOT_PASSWORD, LN_NOTIFICATIONS_FORGOT_PASSWORD_UPDATED,
} from 'locales/constants'
import i18n from 'locales/i18n'

// Constants
import { appLanguages, appLanguagesLocalStoreKey } from 'components/LanguageDropdown/constants'
import { toastConstructor, toastType } from 'components/ToastApp/constants'
import { AuthTabValueDefault } from 'pages/Auth/Login/AuthTabs'

// Store
import {
  onForgotPasswordResult,
  onHandleContactUsLandingFormResult,
  onLoginResult,
  onNonAuth,
  onRegistrationUserResult,
  onResetPasswordResult,
  onSetAuthTabs,
  setToken,
} from 'store/actions/Auth/actions'
import {
  FORGOT_PASSWORD_ACTION,
  LOGOUT,
  ON_HANDLE_CONTACT_US_LANDING_FORM,
  ON_LOGIN,
  ON_REGISTRATION,
  RESET_PASSWORD_ACTION,
} from 'store/actions/Auth/types'
import { showToast } from 'store/actions/ToastsApp/actions'
import { getUserInfo } from 'store/actions/User/actions'
import { cookieAuthToken } from 'store/api'
import {
  contactUsLandingFormAPI,
  forgotPasswordAPI,
  loginUserAPI,
  registrationUserAPI,
  resetPasswordAPI,
} from 'store/api/auth'
import { onLogOut } from 'store/api/user'
import { getErrorMessage, onUserNotAuth } from 'store/sagas/utils'

function* loginUserSaga(action) {
  const expirationDate = new Date()
  expirationDate.setTime(expirationDate.getTime() + 14 * 24 * 60 * 60 * 1000) // Two weeks in milliseconds

  try {
    const { email, password } = action.payload
    const response = yield call(loginUserAPI, { email, password })

    const { token } = response
    yield put(setToken(token))

    // Save token in a cookie
    Cookies.set(cookieAuthToken, token, { expires: expirationDate })

    // Save default language in local storage
    localStorage.setItem(appLanguagesLocalStoreKey, appLanguages?.en)

    const tokenCookies = Cookies.get(cookieAuthToken)
    if (tokenCookies) {
      yield put(getUserInfo())
      // yield put(onGetUserBalance()) TODO: test it
    }

    yield put(onLoginResult(''))
  } catch (error) {
    const result = yield call(getErrorMessage, error)
    yield put(showToast(toastConstructor(toastType.error, result)))
    yield put(onLoginResult(result))
    yield call(onUserNotAuth, error)
  }
}

function* forgotPasswordSaga(action) {
  const t = i18n.t.bind(i18n)
  try {
    const { email } = action.payload
    const response = yield call(forgotPasswordAPI, { email })

    // const { token } = response
    yield put(onForgotPasswordResult({ error: '' }))
    yield put(
      showToast(
        toastConstructor(toastType.success, response?.message, t(LN_NOTIFICATIONS_FORGOT_PASSWORD)),
      ),
    )
  } catch (error) {
    const result = yield call(getErrorMessage, error)
    yield put(showToast(toastConstructor(toastType.error, result)))
    yield put(onForgotPasswordResult({ error: result }))
  }
}

function* resetPasswordSaga(action) {
  try {
    const { email, token, password, repeatPassword } = action.payload
    const response = yield call(resetPasswordAPI, { email, token, password, repeatPassword })
    const expirationDate = new Date()
    expirationDate.setTime(expirationDate.getTime() + 14 * 24 * 60 * 60 * 1000) // Two weeks in milliseconds

    yield put(setToken(response.token))
    // Save token in a cookie
    Cookies.set(cookieAuthToken, response.token, { expires: expirationDate })

    // Save default language in local storage
    localStorage.setItem(appLanguagesLocalStoreKey, appLanguages?.en)

    const tokenCookies = Cookies.get(cookieAuthToken)
    if (tokenCookies) {
      yield put(getUserInfo())
      // yield put(onGetUserBalance()) TODO: test it
    }

    yield put(onLoginResult(''))
  } catch (error) {
    const result = yield call(getErrorMessage, error)
    yield put(showToast(toastConstructor(toastType.error, result)))
    yield put(onResetPasswordResult({ error: result }))
  }
}

function* onHandleContactUsLandingFormSaga(action) {
  const t = i18n.t.bind(i18n)
  try {
    const { name, phone } = action.payload
    yield call(contactUsLandingFormAPI, { name, phone })
    yield put(
      onHandleContactUsLandingFormResult({
        success: t(LN_LANDING_CONTACTS_PAGE_FORM_SUCCESS_MESSAGE),
      }),
    )
  } catch (error) {
    yield put(
      onHandleContactUsLandingFormResult({ error: t(LN_LANDING_CONTACTS_PAGE_FORM_ERROR_MESSAGE) }),
    )
  }
}

function* logoutSaga() {
  const tokenCookies = Cookies.get(cookieAuthToken)

  if (tokenCookies) {
    yield call(onLogOut)
  }

  Cookies.remove(cookieAuthToken)

  yield put(onNonAuth())
}

function* registrationUserSaga(action) {
  try {
    const response = yield call(registrationUserAPI, action.payload)
    yield put(showToast(toastConstructor(toastType.success, response.message)))
    yield put(onRegistrationUserResult(''))
    yield put(onSetAuthTabs(AuthTabValueDefault))
  } catch (error) {
    const result = yield call(getErrorMessage, error)
    yield put(showToast(toastConstructor(toastType.error, result)))
    yield put(onRegistrationUserResult(result))
    yield call(onUserNotAuth, error)
  }
}

export function* watchAuth() {
  yield takeEvery(ON_LOGIN, loginUserSaga)
  yield takeEvery(ON_REGISTRATION, registrationUserSaga)
  yield takeEvery(LOGOUT, logoutSaga)
  yield takeEvery(FORGOT_PASSWORD_ACTION, forgotPasswordSaga)
  yield takeEvery(RESET_PASSWORD_ACTION, resetPasswordSaga)
  yield takeEvery(ON_HANDLE_CONTACT_US_LANDING_FORM, onHandleContactUsLandingFormSaga)
}
